var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 4.5h10c.6 0 1 .4 1 1s-.4 1-1 1h-10c-.6 0-1-.4-1-1s.4-1 1-1zm0 6h10c.6 0 1 .4 1 1s-.4 1-1 1h-10c-.6 0-1-.4-1-1s.4-1 1-1z",
    fill: "#FFAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityMedium);
export default __webpack_public_path__ + "static/media/priority-medium.edb6d1f431cb962759e675389a2fd0e2.svg";
export { ForwardRef as ReactComponent };